import ProductCardsPresenter from "../../../../product-cards/presenter/product-cards.js";

import ProductItemPresenter from "../../../../products-list/presenter/product-item.js";
import ProductCardPresenter from "../../../../product-cards/presenter/product-card.js";
import EmptyItemPresenter from "./empty-item.js";

import InsertsPresenter from "../presenter/inserts.js";

import ProductsView from "../view/products.js";

import {
  createElement, render, replace
} from "../../../../render/render.js";

import {
  ViewType,
  VIEW_TYPE_KEY
} from "../../../const.js";
export default class CategoryProducts extends ProductCardsPresenter {
  constructor(element, changeFilter) {
    super(element);

    this._changeFilter = changeFilter;

    this._compareTriggerPresenter = null;
    this._insertsPresenter = new InsertsPresenter();

    this._productsView = new ProductsView(element);
    this._byButtonListView = null;

    this._updateProducts = this._updateProducts.bind(this);
    this._beforeProductsUpdate = this._beforeProductsUpdate.bind(this);
    this._afterProductsUpdate = this._afterProductsUpdate.bind(this);

    this._ProductItemPresenter = this._getItemPresenter();
  }

  init() {
    super.init();
    this._initInserts();

    this._changeFilter.addLoadStartObserver(this._beforeProductsUpdate);
    this._changeFilter.addLoadObserver(this._updateProducts);
    this._changeFilter.addLoadEndObserver(this._afterProductsUpdate);
  }

  _getItemPresenter() {
    if (this._productsView.isEmpty()) {
      return EmptyItemPresenter;
    }

    const queryParams = document.location.search
      .replace(/^\?/, ``)
      .split(`&`);
    const regExp = new RegExp(`${VIEW_TYPE_KEY}=`, `i`);
    let viewType = queryParams
      .filter((item) => {
        return item.match(regExp);
      })
      .map((item) => {
        return item.replace(regExp, ``);
      })[0];

    let view;

    if (!viewType) {
      view = ViewType.CARD;
    } else {
      view = Object
        .entries(ViewType)
        .find((item) => {
          return item[1] === viewType;
        });
      if (view) {
        view = view[1];
      } else {
        view = ViewType.CARD;
      }
    }

    return (view === ViewType.CARD) ? ProductCardPresenter : ProductItemPresenter;
  }

  _destroyInserts() {
    this._insertsPresenter.destroy();
  }

  _initInserts() {
    const insertsElements = this._productsView.getInsertsElements();

    if (insertsElements.length === 0) {
      return;
    }

    this._insertsPresenter.init(Array.from(insertsElements));
  }

  _updateProducts(data) {
    const destroyItems = (data.by_button === true) ? false : true;
    this.destroy(destroyItems);

    const productsData = data.products;

    if (data.total === 0) {
      const emptyTemplate = this._productsView.getEmptyElement();
      replace(emptyTemplate, this._productsView.getElement());
      this._productsView.updateElement(emptyTemplate);
      this._ProductItemPresenter = this._getItemPresenter();
      this._update();
      return;
    }

    if (data.by_button === true) {
      this._destroyInserts();
      this._addItems(productsData);
      return;
    }

    const newProductsElement = createElement(productsData);
    replace(newProductsElement, this._productsView.getElement());
    this._productsView.updateElement(newProductsElement);
    this._ProductItemPresenter = this._getItemPresenter();
    this._update();
  }

  _addItems(productsData) {
    const listElement = createElement(productsData);
    this._byButtonListView = new this._ProductsListView(listElement);

    const insertionsElements = this._byButtonListView.getInsertions();

    Array.from(this._byButtonListView.getItemsWithInsertions())
      .forEach((item) => {
        render(this._productsListView.getElement(), item);

        const insertionIndex = Array.from(insertionsElements).findIndex((insertion) => insertion === item);

        if (insertionIndex !== -1) {
          return;
        }

        this._initItem(item);
      });

    this._initInserts();
    this._byButtonListView = null;
  }

  _update() {
    super.destroy();
    this._listElement = this._productsView.getElement();
    super.init();
    this._initInserts();
  }

  _beforeProductsUpdate() {
    this._productsView.setUpdate();
  }

  _afterProductsUpdate() {
    this._productsView.setUpdated();
  }
}
